import { InputHTMLAttributes } from 'react'
import s from './SlugInput.module.css'

type Props = InputHTMLAttributes<HTMLInputElement> & {
  error?: string
}

export const SlugInput = ({
  name,
  placeholder,
  value,
  error,
  autoFocus,
  onChange,
  ...rest
}: Props) => {
  return (
    <div className={`${s.field} ${error === '-' ? s.isEmpty : ''}`}>
      <span className={s.prefix}>g.to/</span>
      <input
        name={name}
        className={`${s.input} ${error && error !== '-' ? s.hasError : ''}`}
        placeholder={placeholder}
        onChange={(e) => {
          if (onChange) {
            onChange(e)
          }
        }}
        value={value}
        autoFocus={autoFocus}
        required
        {...rest}
      />
    </div>
  )
}
